import { roleReducer } from './user/roleReducer';
import { heReducer } from './category/heReducer';
import { monHocReducer } from './category/monHocReducer';
import { khoiReducer } from './category/khoiReducer';
import { truongReducer } from './category/truongReducer';
import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { loginReducer } from "./auth/loginReducer";
import { userReducer } from "./user/userReducer";
import { subSystemReducer } from "./sub-sytem/subSystemReducer";
import { appConfigReducer } from './common/appConfigReducer';

const reducers = combineReducers({
    auth: authReducer,
    login: loginReducer,
    user: userReducer,
    subSytem: subSystemReducer,
    truong: truongReducer,
    khoi: khoiReducer,
    monHoc: monHocReducer,
    he: heReducer,
    role: roleReducer,
    appConfig: appConfigReducer
})

export default reducers

export type RootState = ReturnType<typeof reducers>